/**
 * "Help a Job Seeker" share-prompt state. Mirrors `shareStore.ts` — a
 * transient UI trigger, not a preference, so it lives in its own tiny store
 * rather than local component state: the two triggers (resume export,
 * end-of-guide CTA) and the modal that renders live in different parts of
 * the tree.
 *
 * `context` records which surface triggered it, for the analytics event only.
 */

import { create } from 'zustand'

export type SharePromptContext = 'resume' | 'guide'

interface SharePromptState {
  open: boolean
  context: SharePromptContext
  openSharePrompt: (context: SharePromptContext) => void
  closeSharePrompt: () => void
}

export const useSharePromptStore = create<SharePromptState>()((set) => ({
  open: false,
  context: 'resume',
  openSharePrompt: (context) => set({ open: true, context }),
  closeSharePrompt: () => set({ open: false }),
}))
